export type AuthorizationObjectType = {
  permission?: string;
  all?: string[];
  any?: string[];
};

export const isAuthorized = (
  { permission, all, any }: AuthorizationObjectType,
  userPermissions: Array<{ permission: string }>,
) => {
  if (permission) return hasPermission(userPermissions, permission);
  else if (all) return hasAllPermissions(userPermissions, all);
  else if (any) return hasAnyPermission(userPermissions, any);
  else return true;
};

export const hasPermission = (allPermissions, permission) =>
  !!findPermission(allPermissions, permission);

export const hasAllPermissions = (allPermissions, permissions) =>
  !!permissions?.every(
    permission => !!findPermission(allPermissions, permission),
  );

export const hasAnyPermission = (allPermissions, permissions) =>
  !!permissions?.some(
    permission => !!findPermission(allPermissions, permission),
  );

export const findPermission = (allPermissions, permission) =>
  !permission
    ? null
    : allPermissions?.find(
        permissionObject => permissionObject.permission === permission,
      );
